import React from "react";

export const WarningIcon: React.FC<{ width?: string; height?: string }> = ({
  width = "24px",
  height = "24px"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0498 5.24414C11.9242 5.24414 11.8006 5.27483 11.6896 5.33354C11.5831 5.38989 11.4914 5.47041 11.4218 5.56855L4.13493 18.0532L4.12769 18.0642C4.02715 18.2173 4.04158 18.3602 4.12855 18.4848C4.22419 18.6219 4.42537 18.7497 4.70976 18.7497H19.2898C19.5709 18.7497 19.7801 18.6237 19.892 18.473C19.9991 18.3287 20.0171 18.17 19.9492 18.0267L12.6777 5.56855C12.6081 5.47041 12.5164 5.38989 12.4099 5.33354C12.2989 5.27483 12.1753 5.24414 12.0498 5.24414ZM11.2219 4.44965C11.477 4.31469 11.7612 4.24414 12.0498 4.24414C12.3383 4.24414 12.6225 4.31469 12.8776 4.44965C13.1326 4.5846 13.3508 4.77987 13.5131 5.01845L13.5229 5.03274L20.829 17.5504L20.8356 17.5635C21.1015 18.0875 21.0027 18.6544 20.695 19.069C20.3894 19.4808 19.8787 19.7497 19.2898 19.7497H4.70976C4.12414 19.7497 3.60532 19.4825 3.30846 19.0571C3.00532 18.6226 2.95317 18.0413 3.28395 17.5274L10.5766 5.03274L10.5864 5.01845C10.7487 4.77987 10.9669 4.5846 11.2219 4.44965ZM12 14.3398C11.8019 14.3373 11.6126 14.2574 11.4725 14.1173C11.3324 13.9772 11.2526 13.788 11.25 13.5898V9.58984C11.25 9.39093 11.329 9.20017 11.4697 9.05951C11.6103 8.91886 11.8011 8.83984 12 8.83984C12.1989 8.83984 12.3897 8.91886 12.5303 9.05951C12.671 9.20017 12.75 9.39093 12.75 9.58984V13.5898C12.75 13.7888 12.671 13.9795 12.5303 14.1202C12.3897 14.2608 12.1989 14.3398 12 14.3398ZM12.6997 16.0593C12.6997 16.468 12.3684 16.7993 11.9597 16.7993C11.551 16.7993 11.2197 16.468 11.2197 16.0593C11.2197 15.6506 11.551 15.3193 11.9597 15.3193C12.3684 15.3193 12.6997 15.6506 12.6997 16.0593Z"
        fill="#1D1D1B"
      />
    </svg>
  );
};
